import { TransformedUseCase } from '@repo/editor/src/types';

import {
  ALL_SLUG,
  buildTemplatesUrl,
} from '../../../../global/utils/templateParams';
import { UseCaseSelection } from '../type';

export const buildUseCaseUrl = (
  currentSelection: UseCaseSelection,
  useCase?: TransformedUseCase
) =>
  buildTemplatesUrl(
    currentSelection.categorySlug,
    currentSelection.subCategorySlug,
    !useCase || useCase.slug === ALL_SLUG ? undefined : useCase.slug
  );
